import { get, post } from "../../config/api";

class XookeeperService {

    static async getPlannedTasks(data) {
        const url = "/v1/dashboard/xookeeper/workflow/list"
        return await post({ url, data });
    }

    static async getPastTasks(data) {
        const url = "/v1/dashboard/xookeeper/workflow/list"
        return await post({ url, data });
    }

    static async markStepAsCompleted(workflowId, data) {
        const url = `/v1/dashboard/xookeeper/workflow/complete/job/${workflowId}`;
        return await post({ url, data });
    }

    static async checkForBranching(workflowId) {
        const url = `/v1/dashboard/xookeeper/workflow/check/branching/${workflowId}`;
        return await post({ url });
    }

    static async completeBranchedStep(workflowId, data) {
        const url = `/v1/dashboard/xookeeper/workflow/complete/branching/${workflowId}`;
        return await post({ url, data });
    }

    static async getStepsRequiredToCompleteStep(workflowId) {
        const url = `/v1/dashboard/xookeeper/workflow/step/content/${workflowId}`;
        return await post({ url });
    }

    static async getRequiredInternalInputData(workflowId, data) {
        const url = `/v1/dashboard/xookeeper/workflow/input/${workflowId}`;
        return await post({ url, data });
    }

}

export default XookeeperService;